/* saé — header, product page and footer behaviour */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');

  /* ---------- Header ---------- */
  if (!customElements.get('sae-header')) {
    class SaeHeader extends HTMLElement {
      connectedCallback() {
        this.spacer = this.parentElement && this.parentElement.querySelector('.sae-header-spacer');
        this.menuBtn = this.querySelector('.sae-header__menu-btn');
        this.drawer = this.querySelector('.sae-drawer');
        this.closeBtn = this.querySelector('.sae-drawer__close');
        this.toggles = Array.prototype.slice.call(this.querySelectorAll('.sae-nav__toggle'));

        this.onScroll = this.onScroll.bind(this);
        this.measure = this.measure.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);

        this.measure();
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.measure);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.measure);
        var logo = this.querySelector('.sae-header__bar .sae-header__logo-img');
        if (logo && !logo.complete) logo.addEventListener('load', this.measure, { once: true });

        var self = this;
        this.toggles.forEach(function (btn) {
          var item = btn.closest('.sae-nav__item');
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            self.setSub(btn, btn.getAttribute('aria-expanded') !== 'true');
          });
          item.addEventListener('mouseenter', function () {
            if (DESKTOP.matches) self.setSub(btn, true);
          });
          item.addEventListener('mouseleave', function () {
            if (DESKTOP.matches) self.setSub(btn, false);
          });
        });
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);

        if (this.menuBtn) this.menuBtn.addEventListener('click', function () { self.setDrawer(true); });
        if (this.closeBtn) this.closeBtn.addEventListener('click', function () { self.setDrawer(false); });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.measure);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.documentElement.classList.remove('sae-lock');
      }

      setSub(btn, open) {
        if (open) {
          this.toggles.forEach(function (other) {
            if (other !== btn) other.setAttribute('aria-expanded', 'false');
          });
        }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      setDrawer(open) {
        if (!this.drawer) return;
        this.drawer.hidden = !open;
        this.classList.toggle('is-open', open);
        if (this.menuBtn) this.menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('sae-lock', open);
        if (open && this.closeBtn) this.closeBtn.focus();
        if (!open && this.menuBtn) this.menuBtn.focus();
      }

      onDocClick(e) {
        if (!this.contains(e.target)) {
          var self = this;
          this.toggles.forEach(function (btn) { self.setSub(btn, false); });
        }
      }

      onKey(e) {
        if (e.key !== 'Escape') return;
        var self = this;
        this.toggles.forEach(function (btn) { self.setSub(btn, false); });
        if (this.drawer && !this.drawer.hidden) this.setDrawer(false);
      }

      /* Height of the full (not scrolled) header, so the page starts below it */
      measure() {
        var wasScrolled = this.classList.contains('is-scrolled');
        if (wasScrolled) this.classList.remove('is-scrolled');
        var h = this.getBoundingClientRect().height;
        if (wasScrolled) this.classList.add('is-scrolled');
        document.documentElement.style.setProperty('--sae-header-h', h + 'px');
        document.documentElement.style.setProperty('--m-header-height', h + 'px');
        if (window.MinimogSettings) window.MinimogSettings.headerHeight = h;
      }

      onScroll() {
        var scrolled = window.scrollY > 40;
        if (scrolled !== this.classList.contains('is-scrolled')) {
          this.classList.toggle('is-scrolled', scrolled);
          if (!scrolled) {
            var self = this;
            this.toggles.forEach(function (btn) { self.setSub(btn, false); });
          }
        }
      }
    }
    customElements.define('sae-header', SaeHeader);
  }

  /* ---------- Cart count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('m:hidden', count === 0);
    });
  }

  function openCart() {
    var drawer = document.querySelector('m-cart-drawer');
    var drawerOn = window.MinimogSettings && window.MinimogSettings.enable_cart_drawer;
    if (drawer && drawerOn && typeof drawer.onCartDrawerUpdate === 'function' && typeof drawer.open === 'function') {
      drawer.onCartDrawerUpdate();
      drawer.open();
      return true;
    }
    return false;
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (!root || root.dataset.saeReady) return;
    root.dataset.saeReady = 'true';

    var variantsEl = root.querySelector('[data-sae-variants]');
    var stringsEl = root.querySelector('[data-sae-strings]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    var form = root.querySelector('.sae-product__form');
    var idInput = root.querySelector('[data-sae-variant-id]');
    var addBtn = root.querySelector('[data-sae-add]');
    var priceEl = root.querySelector('[data-sae-price]');
    var errorEl = root.querySelector('[data-sae-error]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-sae-option]'));
    var track = root.querySelector('[data-sae-track]');
    var counter = root.querySelector('[data-sae-current]');

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    function setButton(v) {
      if (!addBtn) return;
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = strings.unavailable || 'Unavailable';
      } else if (!v.available) {
        addBtn.disabled = true;
        addBtn.textContent = strings.soldOut || 'Sold out';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = strings.add || 'Add to bag';
      }
    }

    function onOptionChange() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-sae-option-value]');
        if (label) label.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      setButton(v);
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare ? '<s class="sae-product__compare">' + escapeHtml(v.compare) + '</s> ' : '') +
          '<span>' + escapeHtml(v.price) + '</span>';
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.media && track) {
        var slide = track.querySelector('[data-media-id="' + v.media + '"]');
        if (slide) {
          if (DESKTOP.matches) {
            var top = slide.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: top, behavior: 'smooth' });
          } else {
            track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
        }
      }
      if (errorEl) errorEl.hidden = true;
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', onOptionChange); });

    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled || addBtn.getAttribute('aria-busy') === 'true') return;
        addBtn.setAttribute('aria-busy', 'true');
        var label = addBtn.textContent;
        addBtn.textContent = strings.adding || 'Adding…';
        if (errorEl) errorEl.hidden = true;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (r) {
            if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to bag');
            return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
              try { MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'sae-product', cart: cart }); } catch (err) {}
            }
            if (!openCart()) window.location.href = base + 'cart';
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
          })
          .then(function () {
            addBtn.removeAttribute('aria-busy');
            if (addBtn.textContent === (strings.adding || 'Adding…')) addBtn.textContent = label;
          });
      });
    }

    /* Phone carousel counter */
    if (track && counter) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
          counter.textContent = i;
          ticking = false;
        });
      }, { passive: true });
    }
  }

  /* ---------- Footer country selector ---------- */
  function initAutosubmit(scope) {
    (scope || document).querySelectorAll('[data-sae-autosubmit]').forEach(function (sel) {
      if (sel.dataset.saeReady) return;
      sel.dataset.saeReady = 'true';
      sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.sae-product').forEach(initProduct);
    initAutosubmit(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
